module.exports = __webpack_public_path__ + "img/icon-loading.1481dd6e.svg";